<bz-dialog-layout [heading]="(processing() ? 'Processing' : 'BATCH_RECOVERY_TITLE') | translate"
                  [subheading]="processing() ? '' : ((stalled() ? 'BATCH_RECOVERY_STALLED_DESCRIPTION' : 'BATCH_RECOVERY_AWAITING_DESCRIPTION') | translate)">

  <div bzDialogContent class="layout-column timecard-dialog-body" appBringozIdGenerator="payrollRecoveryDialog">

    @if (processing()) {
      <div class="layout-column padding-30">
        <div class="br-body-1 margin-bottom-20" translate>TIMEKEEPING_EXPORT_PAYROLL_IN_PROGRESS</div>
        <div class="layout-row layout-align-start-center">
          <bz-progress class="flex" tone="secondary" [value]="progress()" [ariaLabel]="'Processing' | translate"></bz-progress>
          <span class="br-body-1 font-weight-500 margin-left-10">{{ progress() }}%</span>
        </div>
      </div>
    } @else if (!canRecover) {
      <div class="br-body-1" translate>BATCH_RECOVERY_NO_PERMISSION</div>
    }

    @if (options()?.totals; as totals) {
      <div class="layout-row layout-align-space-around-center">
        <div class="layout-column layout-align-start-center">
          <span class="br-body-2" translate>BATCH_RECOVERY_TOTAL</span>
          <span>{{ totals.total }}</span>
        </div>
        <div class="layout-column layout-align-start-center">
          <span class="br-body-2" translate>BATCH_RECOVERY_COMPLETED</span>
          <span>{{ totals.completed }}</span>
        </div>
        <div class="layout-column layout-align-start-center">
          <span class="br-body-2" translate>BATCH_RECOVERY_FAILED</span>
          <span>{{ totals.failed }}</span>
        </div>
        <div class="layout-column layout-align-start-center">
          <span class="br-body-2" translate>BATCH_RECOVERY_TIMED_OUT</span>
          <span>{{ totals.timeOut }}</span>
        </div>
      </div>
    }

    @if (pendingAction() === recoveryActions.SKIP) {
      <div class="br-body-1" translate>BATCH_RECOVERY_SKIP_CONFIRM</div>
    }
    @if (pendingAction() === recoveryActions.CANCEL) {
      <div class="br-body-1" translate>BATCH_RECOVERY_CANCEL_CONFIRM</div>
    }
  </div>

  <div bzDialogActions>
    @if (pendingAction()) {
      <bz-button variant="tertiary" appBringozIdGenerator="batchRecoveryConfirmCancelBtn"
                 [disabled]="loading()" (clicked)="onBack()">
        <span translate>BATCH_RECOVERY_BACK</span>
      </bz-button>
      <bz-button tone="danger" appBringozIdGenerator="batchRecoveryConfirmBtn"
                 [disabled]="loading()" (clicked)="onAction(pendingAction())">
        <span translate>BATCH_RECOVERY_CONFIRM</span>
      </bz-button>
    } @else if (!processing()) {
      @if (closable()) {
        <bz-button variant="tertiary" appBringozIdGenerator="batchRecoveryCloseBtn" (clicked)="onClose()">
          <span translate>Close</span>
        </bz-button>
      }
      @if (canCancel()) {
        <bz-button variant="tertiary" tone="danger" appBringozIdGenerator="batchRecoveryCancelBtn"
                   [disabled]="loading()" (clicked)="onAction(recoveryActions.CANCEL)">
          <span translate>BATCH_RECOVERY_CANCEL</span>
        </bz-button>
      }
      @if (canSkip()) {
        <bz-button variant="tertiary" appBringozIdGenerator="batchRecoverySkipBtn"
                   [disabled]="loading()" (clicked)="onAction(recoveryActions.SKIP)">
          <span translate>BATCH_RECOVERY_SKIP</span>
        </bz-button>
      }
      @if (canRetry()) {
        <bz-button tone="secondary" appBringozIdGenerator="batchRecoveryRetryBtn"
                   [disabled]="loading()" (clicked)="onAction(recoveryActions.RETRY)">
          <span translate>BATCH_RECOVERY_RETRY</span>
        </bz-button>
      }
    }
  </div>

</bz-dialog-layout>
